import React, { useState } from 'react';
import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
  Button,
  CircularProgress,
  alpha,
} from '@mui/material';
import { Close, LockPersonRounded, InfoOutlined } from '@mui/icons-material';
import { lockReport } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function FacilityReportQuaterLock({ open, onClose, report, onRefetch }) {
  const [loading, setLoading] = useState(false);

  const handleRevertQuarter = () => {
    setLoading(true);
    lockReport(report?.reportId)
      .then((response) => {
        onRefetch();
        onClose();
        openNotification({
          type: 'success',
          title: 'Successful',
          message: 'Quarter has been successfully reserved',
        });
      })
      .catch((error) => {
        const errMsg = error?.data?.result?.status?.desc || "An error occurred";
        onClose();
        openNotification({
          type: 'error',
          title: 'Failed',
          message: errMsg,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog 
      open={open} 
      fullWidth 
      maxWidth="xs"
      PaperProps={{
        sx: { borderRadius: '20px', p: 1 }
      }}
    >
      {/* Header Area */}
      <Box display="flex" alignItems="center" justifyContent="space-between" px={2} pt={1}>
        <Box display="flex" alignItems="center" gap={1}>
          <LockPersonRounded color="primary" sx={{ fontSize: 20 }} />
          <Typography variant="subtitle2" fontWeight={700}>
            Confirmation Required
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" disabled={loading}>
          <Close fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent sx={{ mt: 1 }}>
        <Stack spacing={3} alignItems="center" textAlign="center">
          {/* Visual Indicator */}
          <Box 
            sx={{ 
              width: 60, 
              height: 60, 
              borderRadius: '50%', 
              bgcolor: alpha('#1976d2', 0.1), 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center' 
            }}
          >
            <InfoOutlined color="primary" sx={{ fontSize: 32 }} />
          </Box>

          <Box>
            <Typography variant="body1" fontWeight={700} gutterBottom>
              Reserve {report?.reportTitle}?
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ px: 2 }}>
              You are about to reserve this quarter for QAQC recording. This action will restrict standard entries for this period.
            </Typography>
          </Box>

          <Alert 
            severity="info" 
            variant="outlined"
            sx={{ 
              borderRadius: '12px', 
              width: '100%', 
              border: '1px dashed',
              bgcolor: alpha('#0288d1', 0.02)
            }}
          >
            <Typography variant="caption" fontWeight={600} display="block">
              Target Period: {report?.reportTitle} ({new Date().getFullYear()})
            </Typography>
          </Alert>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 1, justifyContent: 'center', gap: 1 }}>
        <Button
          fullWidth
          variant="text"
          color="inherit"
          onClick={onClose}
          disabled={loading}
          sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 700 }}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disableElevation
          onClick={handleRevertQuarter}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
          sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 700, py: 1 }}
        >
          {loading ? 'Processing...' : 'Confirm Reservation'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}